import { graphql } from "gatsby";
import React, { useCallback, useState } from "react";
import { codeWashValidator } from "../utility/formatters";
import ItemsGrid from "./items-grid";
//import CodeValidatorModal from "./code-validator-modal";
import slugify from "@sindresorhus/slugify";

const CodeValidator = ({ data }) => {
  const errorCode = data?.errorCode;
  const systemErrorMessage = data?.systemError;
  const [currentValue, setCurrentValue] = useState({
    error: false,
    value: "",
  });

  const retailers = [
    { key: "MW", value: "Mediaworld" },
    { key: "EP", value: "Epi" },
    { key: "JY", value: "Jointly" },
    { key: "PP", value: "Epp" },
    { key: "DO", value: "Domica" },
    { key: "EU", value: "Euronics" },
    { key: "UI", value: "Unieuro" },
    { key: "AM", value: "Amazon" },
    { key: "VG", value: "Virgin Fiber" },
    { key: "PL", value: "Plenitude" },
    { key: "00", value: "" },
  ];

  const [contentFromZuora, setContentFromZuora] = useState();
  const [showWashpass, setShowWashpass] = useState(false);
  const [error, setError] = useState();
  const [systemError, setSystemError] = useState();
  const [retailer, setRetailer] = useState("");

  const checkRetailer = (currentValue) => {
    const retailer = retailers.filter(
      (retailer) => retailer.key === currentValue.value?.substring(0, 2)
    );
    setRetailer(retailer?.[0]?.value);
  };

  const activateCoupon = useCallback(async () => {
    const url = `/headless-api/validatorCode?code=${currentValue.value}`;
    try {
      const response = await fetch(`${url}`, { method: "PUT" });
      if (!response.ok) {
        setSystemError(systemErrorMessage || "System Error");
        throw new Error(`Error ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      if (response.status === 200 && data.data.success) {
        setContentFromZuora(data);
        setShowWashpass(true);
        const sections = document?.getElementsByTagName("section");
        const sectionsArray = Array?.from(sections);
        sectionsArray?.map((section) => section.classList.add("d-none"));
        const codeValidatorSection = document?.getElementById("code-validator");
        codeValidatorSection?.classList?.remove("d-none");
        const mainBenefitsSection = sectionsArray?.find(
          (item) => item.className === "main-benefits d-none"
        );
        mainBenefitsSection?.classList?.remove("d-none");
      } else if ((response.status === 200 && !data.data.success) || response.status === 404) {
        setError(errorCode || "An error has occurred");
      } else {
        setSystemError(systemErrorMessage || "System Error");
      }
    } catch (err) {
      console.error("err: ", err);
      setSystemError(systemErrorMessage || "System Error");
    }
  }, [errorCode, currentValue.value, systemErrorMessage]);

  const formatWarning = data?._16CharacterText;

  const onBlur = useCallback(
    (e) => {
      if (codeWashValidator(e.target.value)) {
        setCurrentValue({
          value: e.target.value,
          error: !!e.target.value && !codeWashValidator(e.target.value) ? formatWarning : null,
        });
      }
    },
    [formatWarning]
  );

  const onChange = useCallback(
    (e) => {
      setCurrentValue({
        value: e.target.value,
        error: !!e.target.value && !codeWashValidator(e.target.value) ? formatWarning : null,
      });
      setError(null);
      setSystemError(null);
    },

    [formatWarning]
  );
  // const closeCodeValidatorModal = useCallback(() => setError(null), []);

  const findRetailerDynamic = (data, retailer) => {
    const dynamic =
      retailer !== ""
        ? data?.dynamic?.find((dynamic) => dynamic?.retailer?.[0] === retailer)
        : data?.dynamic?.find((dynamic) => dynamic?.retailer?.length < 1);

    const noRetailerDynamic = data?.dynamic?.find((dynamic) => dynamic?.retailer?.length < 1);
    return dynamic
      ? dynamic?.dynamicWebContent
      : noRetailerDynamic
      ? noRetailerDynamic?.dynamicWebContent
      : null;
  };

  const dynamicContent = findRetailerDynamic(data, retailer);

  return (
    <>
      {data?.anchorDesktop && (
        <span id={slugify(data.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <section id="code-validator" className="section form pb-0">
        <div className="container">
          <div className="row">
            <div className="col-12 px-0">
              {!showWashpass && (
                <div className="form__container text-center pb-0">
                  <div className="pb-3"> {data?.introduction}</div>
                  <label className="form__input-label" htmlFor="codeWashpass">
                    <input
                      className="form__input"
                      style={{ fontSize: "16px" }}
                      type="text"
                      id="codeWashpass"
                      name="codeWashpass"
                      maxLength={16}
                      aria-label={data?.inputPlaceholder}
                      onChange={onChange}
                      value={currentValue.value}
                      placeholder={data?.inputPlaceholder}
                      onBlur={onBlur}
                      data-required={true}
                    />
                    {currentValue.error && (
                      <span className="form__error-message form__error-message--code-validator d-inline">
                        {currentValue ? formatWarning : currentValue.error}
                      </span>
                    )}
                    {error && (
                      <span className="form__error-message form__error-message--code-validator d-inline pt-2">
                        {error}
                      </span>
                    )}
                  </label>
                  <button
                    className="btn-link"
                    disabled={!codeWashValidator(currentValue.value)}
                    onClick={() => {
                      activateCoupon();
                      checkRetailer(currentValue);
                    }}
                  >
                    {data?.ctaLabel}
                  </button>
                  {/* {error && (
                    <CodeValidatorModal
                      show={error}
                      onHide={closeCodeValidatorModal}
                      errorMessage={error}
                      anchor={data?.anchorDesktop?.value}
                    />
                  )} */}
                  {systemError && (
                    <div
                      className="form__system-error-message mt-5"
                      dangerouslySetInnerHTML={{ __html: systemError }}
                    ></div>
                  )}
                </div>
              )}
              {showWashpass && dynamicContent && (
                <ItemsGrid
                  data={dynamicContent}
                  origin="code-validator"
                  dataZuora={contentFromZuora}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CodeValidator;

export const fragment = graphql`
  fragment WashpassCodeValidatorFragment on LiferayWashpassCodeValidator {
    anchorDesktop
    anchorMobile
    inputPlaceholder
    _16CharacterText
    errorCode
    systemError
    ctaLabel
    introduction
    dynamic {
      retailer
      dynamicWebContent {
        ...DynamicTriplettaListingFragment
      }
    }
  }
`;
